import { render, staticRenderFns } from "./DocumentPreviewer.vue?vue&type=template&id=124da723&"
import script from "./DocumentPreviewer.vue?vue&type=script&lang=js&"
export * from "./DocumentPreviewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports